(function(){
  const msg = document.getElementById('newsletterMessage');

  // Перевіряємо URL на ?customer_posted=true
  const params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true') {
    // Показуємо вже існуючий у розмітці span замість створення нового
    if (msg) {
      const successSpan = msg.querySelector('.newsletter-success');
      if (successSpan) {
        successSpan.removeAttribute('hidden');
        successSpan.classList.remove('hidden', 'visually-hidden', 'is-hidden');
        successSpan.style.display = 'inline';
      }
    }

    // Миттєво переносимо користувача до футера
    const footer = document.querySelector('footer');
    if (footer) {
      footer.scrollIntoView({ behavior: 'auto', block: 'start' });
    }

    // Через 1 секунду очищаємо URL без перезавантаження
    setTimeout(() => {
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }, 1000);
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.sticky-btn-wrap');
  const footer = document.querySelector('footer');

  if (!btn || !footer) return;

  function updateButtonPosition() {
    const footerRect = footer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (footerRect.top < windowHeight) {
      // Футер з'явився у видимості → піднімаємо кнопку над футером
      const overlap = windowHeight - footerRect.top;
      btn.style.bottom = `${overlap - 20}px`; // 20px відступ
    } else {
      // Футер ще не видно → кнопка принизу екрану
      btn.style.bottom = '0px';
    }
  }

  // Робимо функцію доступною глобально для виклику з інших скриптів
  window.updateStickyButtonPosition = updateButtonPosition;

  window.addEventListener('scroll', updateButtonPosition);
  window.addEventListener('resize', updateButtonPosition);

  // Виставимо початкове положення
  updateButtonPosition();
});

document.addEventListener('click', function (e) {
  if (e.target.closest('.happy-customers-reviewers-show-more')) {
    setTimeout(() => {
      if (window.updateStickyButtonPosition) {
        window.updateStickyButtonPosition();
      }
    }, 50);
  }
});
